import { createContext, useContext } from "react"
import {
  uploadMonitor,
  type UploadMonitor,
} from "@/lib/powersync/uploadMonitor"

const UploadMonitorContext = createContext<UploadMonitor>(uploadMonitor)

/** The app's upload monitor; tests can provide their own. */
export function useUploadMonitor(): UploadMonitor {
  return useContext(UploadMonitorContext)
}

export const UploadMonitorProvider = UploadMonitorContext.Provider
